<template>
  <div class="search-content">
    <div class="search-top">
      <div class="select_btn">
        <el-select class="select_btn_style" v-model="filters.onlineStatus" placeholder="上线状态" clearable>
          <el-option v-for="(item, i) in onlineStatusList" :key="i" :label="item.paramValue"
            :value="item.paramKey"></el-option>
        </el-select>
      </div>
      <div class="select_btn" v-if="showAnlysis">
        <el-select class="select_btn_style" v-model="filters.anlysisStatus" placeholder="解析状态" clearable>
          <el-option v-for="(item, i) in anlysisList" :key="i" :label="item.paramValue"
            :value="item.paramKey"></el-option>
        </el-select>
      </div>
      <div class="select_btn" v-if="showDept">
        <el-select class="select_btn_style" v-model="filters.deptLevelCodeSelect" placeholder="版权方" clearable>
          <el-option v-for="(item, i) in deptList" :key="i" :label="item.deptName"
            :value="item.deptLevelCode"></el-option>
        </el-select>
      </div>
      <el-input class="input" placeholder="视频名称/讲师姓名" v-model="filters.name" />
      <template v-if="!showMore">
        <butn btntype="primary" title="查询" @click.native="searchHandle"></butn>
        <butn title="重置" @click="resetData" class="czButn"></butn>
        <div v-if="showAdvanced" class="search-arrow-btn" @click="handleMore">高级筛选<i class="el-icon-arrow-down"></i>
        </div>
      </template>
    </div>
    <div v-show="showMore" class="search-bottom">
      <div style="font-size: 14px;">解析内容：</div>
      <div class="search-select">
        <div class="search-select__text">类型:</div>
        <el-select class="search-select_style" v-model="filters.filterType" placeholder="综合" clearable>
          <el-option v-for="(item, i) in filterTypeList" :key="i" :label="item.paramValue"
            :value="item.paramKey"></el-option>
        </el-select>
      </div>
      <div class="search-select">
        <div class="search-select__text">条件:</div>
        <el-select class="search-select_style" v-model="filters.filterRequire" placeholder="任意符合" clearable>
          <el-option v-for="(item, i) in filterRequireList" :key="i" :label="item.paramValue"
            :value="item.paramKey"></el-option>
        </el-select>
      </div>
      <el-input class="input" placeholder="请输入关键词，每个关键词中间用顿号分隔。" v-model="filters.keyWords" />
      <butn btntype="primary" title="查询" @click.native="searchHandle"></butn>
      <butn title="重置" @click="resetData" class="czButn"></butn>
      <div class="search-arrow-btn" @click="handleMore">收起筛选<i class="el-icon-arrow-up"></i></div>
    </div>
  </div>
</template>
<script>
import butn from "@/components/button/index";
import { collegeSimpleFullList } from "@/api/dept";
import { getSysParamByTypes } from "@/api/sysParam";
export default {
  components: { butn },
  props: {
    showAdvanced: {
      type: Boolean,
      default: true,
    },
    showAnlysis: {
      type: Boolean,
      default: true,
    },
    showDept: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      showMore: false,
      filters: {

      },
      deptList: [],
      onlineStatusList: [],
      anlysisList: [],
      filterRequireList: [],
      filterTypeList: [],
    };
  },
  created() {
    let types = ["ONLINE_STATUS"];
    if (this.showAnlysis) {
      types.push("ANLYSIS_STATUS");
    }
    if (this.showAdvanced) {
      types.push("AI_FILTER_REQUIRE")
      types.push("AI_FILTER_TYPE")
    }
    this.getTypes(types);
    if (this.showDept) {
      collegeSimpleFullList().then(res => {
        if (!res || res.code != 0) return;
        this.deptList = res.data;
      });
    }

  },

  methods: {

    getTypes(types) {
      getSysParamByTypes({ types: types }).then((res) => {
        if (!res || res.code != 0) return;
        this.onlineStatusList = res.data["ONLINE_STATUS"];
        if (res.data["ANLYSIS_STATUS"]) {
          this.anlysisList = res.data["ANLYSIS_STATUS"];
        }
        if (this.showAdvanced) {
          this.filterRequireList = res.data["AI_FILTER_REQUIRE"];
          this.filterTypeList = res.data["AI_FILTER_TYPE"];
        }

      });

    },

    searchHandle() {
      this.$emit("search", {...this.filters})
    },
    resetData() {
      this.filters = {};
      this.$emit("search", {})
    },

    handleMore() {
      this.showMore = !this.showMore;
    },
  },
  computed: {},
};
</script>
<style lang='scss' scoped>
.search-content {
  // float: right;
}

.search-top {
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: flex-end;

  .input {
    width: 160px;
    margin: 0 10px;
  }
}

.search-bottom {
  margin-bottom: 16px;
  padding: 6px 12px;
  background: #EFF3F6;
  display: flex;
  align-items: center;
  border-radius: 4px;

  .input {
    flex: 1;
    margin-right: 10px;
  }

  .search-select {
    display: flex;
    align-items: center;
    margin-right: 12px;
    background: #fff;
    border-radius: 2px;
    border: 1px solid #DCDFE6;

    &__text {
      margin-left: 10px;
      font-size: 14px;
      color: #96A1B2;
      line-height: 22px;
    }

    .search-select_style {
      width: 120px;

      /deep/input {
        border: none;
        border-radius: 0;
      }

      /deep/.el-input.is-focus .el-input__inner {
        border-color: #fff;
      }

      /deep/.el-input__inner:focus {
        border-color: #fff;
      }
    }
  }
}

.search-arrow-btn {
  margin-left: 12px;
  font-size: 14px;
  color: #343C4A;
  line-height: 20px;
  cursor: pointer;

  i {
    margin-left: 5px;
  }

}
</style>